

























import { Component, Inject, Prop, Vue } from 'vue-property-decorator';

import { FeedProduct } from '../../../../models';

import InformationRow from '@/components/display/information-row.vue';
import SitePicker from '@/components/site-picker.vue';
import { Site } from '@/api';
import { FeedProductService } from '../../../../services';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		InformationRow,
		SitePicker,
	},
})
export default class FeedProductSite extends Vue {
	@Prop({ required: true, type: Object })
	public feedProduct!: FeedProduct;

	@Inject('feedProductService')
	private service!: FeedProductService;

	public editing: boolean = false;
	public newSite: Site | null = null;

	private toast: Toast = new Toast();

	public created(): void {
		this.newSite = this.feedProduct.site;
	}

	public toggleEditing(): void {
		this.editing = !this.editing;
		if (this.editing === false) {
			this.newSite = this.feedProduct.site;
		}
	}

	public async updateSite(): Promise<void> {
		if (!this.newSite?.id) {
			return;
		}
		this.feedProduct.siteId = this.newSite.id;
		const updateResult = await this.service.updateProduct(this.feedProduct);
		if (updateResult?.errorMessage) {
			this.toast.makeToast(updateResult.errorMessage, 'Error', 'danger');
			return;
		}
		this.toast.makeToast(`Site changed to ${this.newSite.name}`, 'Site updated', 'success');
		this.editing = false;
	}
}
